module.exports = __webpack_public_path__ + "assets/img/returnBtn-83905c07.png";